import { tokens } from "@blurb/codex-react";
import React, { ComponentProps, ReactNode } from "react";
import { DefaultTooltipContent } from "recharts";
import { Body, Label } from "../Typography";
import { createStyles } from "@mantine/core";
import { ChartLegendItem } from "./ChartLegend";
import { ValueType } from "recharts/types/component/DefaultTooltipContent";

const useStyles = createStyles(() => ({
  chartTooltip: {
    minWidth: 144,
    display: "flex",
    flexDirection: "column",
    padding: tokens.spacing[2],
    gap: tokens.spacing[2],
    backgroundColor: tokens.color.primitive.base.white,
    borderColor: tokens.color.semantic.border.faint,
    borderWidth: 1,
    borderRadius: tokens.radius.sm,
    boxShadow: "0 4px 12px 1px rgba(0, 0, 0, 0.10)",
  },
  chartTooltipHeading: {
    color: tokens.color.semantic.text.subtle,
  },
  chartTooltipItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: tokens.spacing[2],
  },
}));

type ChartTooltipProps = ComponentProps<typeof DefaultTooltipContent> & {
  label?: string;
  formatValue?: (value: ValueType) => ReactNode | string;
};

export const ChartTooltip: React.FC<ChartTooltipProps> = ({ label, payload, formatValue }) => {
  const { classes } = useStyles();

  if (!payload || payload.length < 1) return null;

  return (
    <div className={classes.chartTooltip}>
      {label && <Label className={classes.chartTooltipHeading}>{label}</Label>}
      {payload.map((p, idx) => (
        <div key={idx} className={classes.chartTooltipItem}>
          <ChartLegendItem
            item={{
              value: p.name?.toString(),
              color: p.color,
            }}
          />
          <Body weight="bold" size="sm">
            {formatValue && p.value !== undefined ? formatValue(p.value) : p.value}
          </Body>
        </div>
      ))}
    </div>
  );
};
